/**
 * Normalizes the checkout seat-count query param so pricing flows always start from a valid value.
 */
export function parseCheckoutQuantityParam(value: string | null | undefined): number {
  if (!value) {
    return 1;
  }

  const normalizedValue = value.trim();
  if (!/^\d+$/.test(normalizedValue)) {
    return 1;
  }

  const parsedQuantity = Number.parseInt(normalizedValue, 10);
  return parsedQuantity > 0 ? parsedQuantity : 1;
}
